import { Authenticator } from '@aws-amplify/ui-react';
import { useLocation } from 'react-router-dom';
import PostLoginRedirect from '../components/PostLoginRedirect';

const LoginRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get('error');

  const isInactive = error === 'inactive';

  return (
    <div style={{ maxWidth: 400, margin: '0 auto', paddingTop: '2rem' }}>
      {isInactive && (
        <p style={{ color: 'red', marginBottom: '1rem' }}>
          Your account is inactive. Please contact your organization admin.
        </p>
      )}

      <Authenticator initialState="signIn">
        {() =>
          isInactive
            ? null // do NOT run PostLoginRedirect again
            : <PostLoginRedirect />
        }
      </Authenticator>
    </div>
  );
};

export default LoginRedirect;